import createStore from "@/utils/create-store";
import Model from "@/models/public/dicts";

export default createStore({ Model });
